<template>
  <b-card header="Retention Percentage" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
      <div v-if="!e_retention" class="row">
          <div class="col-12">
              <p class="font-weight-bold pt-0 mb-3">Change the default retention for the company's CCO's</p>
          </div>

          <div class="col-xl-4 form-group">
              <label class="form-label" for="genius_retention_agreed">Retention Percentage</label>
              <p>{{ company.default_retention_percentage }}%</p>
          </div>
          
          <div class="col-12 text-right">
              <button @click="edit_form()" class="btn orcaBtn blueBtn sm_btn mb-2" style="width: auto !important;">Edit Retention</button>
          </div>
      </div>

      <div v-else-if="e_retention" class="row">
          <ValidationObserver ref="editChargesForm" slim tag="div" class="col-12">
              <div class="col-12">
                  <p class="font-weight-bold pt-0 mb-3">Change the default retention for the company's CCO's</p>
              </div>

              <div class="col-xl-4 form-group">
                  <label class="form-label" for="genius_retention_agreed">Retention Percentage</label>
                  <input v-model="edit_retention.default_retention_percentage" @input="handleInput" type="number" id="company_name" name="company_name" class="form-input" autocomplete="off" autofocus>
              </div>

              <!-- CANCEL AND SUBMIT BUTTONS FOR ACTIONS -->
              <div class="row mb-3 mt-2">
                <div class="col-xl-6">
                  <button @click.prevent="cancel_form()" class="btn orcaBtn grey_bg sm_btn w-100">Cancel</button>
                </div>
                <div class="col-xl-6">
                  <button @click="submit_form()" type="submit" class="btn orcaBtn sm_btn w-100">Update Retention Information</button>
                </div>
              </div>
      
          </ValidationObserver>   
      </div>
  </b-card>
</template>

<script>
import Multiselect from "vue-multiselect";
import BootstrapToggle from 'vue-bootstrap-toggle';

import { getChangedFields } from 'utils/utils';

export default {
  name: "company_retention_percentage",
  components: {
    Multiselect,
    BootstrapToggle
  },
  props: [
    'company'
  ],
  data() {
    return {
      e_retention: false,
      edit_retention: {},
      original_retention: {},
    }
  },
  computed: {
  
  },
  methods: {
      edit_form() {
          this.edit_retention = Object.assign({}, this.company);
          this.original_retention = Object.assign({}, this.company); 
          this.e_retention = !this.e_retention;
      },

      cancel_form() {
          this.edit_retention = {};
          this.e_retention = false;
      },

      submit_form() {
        let charges_promises = [];

          
        // Use the new function to get changed fields
        let changed_fields = [
          ...getChangedFields(this.original_retention, this.edit_retention),
        ];


        charges_promises.push(new Promise(resolve => {
          let submit_ppi = {
            company_id: this.company.id,
            default_retention_percentage: this.edit_retention.default_retention_percentage,
            log_by_type: 'App\\Models\\Users\\User',
            log_by_id: this.$store.state.auth.me.id
          }

          // save updates to database
          axios.patch(this.crmApiPath + 'company/' + this.company.id, submit_ppi).then(() => resolve());
        }));


        
        if (changed_fields.length > 0) {
          // Send changed fields through AJAX on email
          charges_promises.push(new Promise(resolve => {
            axios.post(this.crmApiPath + 'company/send_changed_email', {
              title: 'RETENTION PERCENTAGE',
              company_id: this.company.id,
              changes: changed_fields,
            }).then(() => resolve());
          }));
        }


        Promise.all(charges_promises).then(() => {
          this.$bus.$emit('company::reload', {action: true});
        })
      },

      handleInput() {
        this.edit_retention.default_retention_percentage = parseFloat(
          this.edit_retention.default_retention_percentage
        );
      }
  }
}
</script>
